import { render, staticRenderFns } from "./series.vue?vue&type=template&id=5486d88e&scoped=true&"
import script from "./series.vue?vue&type=script&lang=js&"
export * from "./series.vue?vue&type=script&lang=js&"
import style0 from "./series.vue?vue&type=style&index=0&id=5486d88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5486d88e",
  null
  
)

component.options.__file = "series.vue"
export default component.exports